import * as React from "react";
import { IconProps } from "./types";

export const BluetoothOnIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M6 7L18 17L12 22V2L18 7L6 17"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(BluetoothOnIcon as React.FunctionComponent).displayName = "BluetoothOnIcon";

export default BluetoothOnIcon;
